var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwoArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.866,
    height: 11.238,
    viewBox: "0 0 15.866 11.238",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_299",
    "data-name": "Group 299",
    transform: "translate(-64 -120.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M64.661,123.638H77.609l-1.185,1.185a.661.661,0,1,0,.935.935l2.314-2.314a.661.661,0,0,0,0-.935L77.358,120.2a.661.661,0,0,0-.935.935l1.185,1.185H64.661a.661.661,0,0,0,0,1.322Z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M79.207,250.316H66.259l1.185-1.185a.661.661,0,0,0-.935-.935L64.2,250.509a.661.661,0,0,0,0,.935l2.314,2.314a.661.661,0,1,0,.935-.935l-1.185-1.185H79.207a.661.661,0,0,0,0-1.322Z",
    transform: "translate(-0.002 -122.711)",
    fill: "#666"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoArrow);
export default __webpack_public_path__ + "static/media/two-arrow.5ab58067a57c75fc02767efea5564a9d.svg";
export { ForwardRef as ReactComponent };